// extracted by mini-css-extract-plugin
module.exports = {"input":"AuthTabs_input__hgYUX","submit":"AuthTabs_submit__3a-C1","togglePassVisibility":"AuthTabs_togglePassVisibility__pm_46"};